export function setBootStatus(message) {
  let a = document.getElementById("boot-status");
  if (a) {
    a.innerText = message;
  }
}
